/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IAaiVisitor } from '../../visitors/IAaiVisitor';

/**
 * A node visitor for the AsyncAPI data model.
 * 
 * @author eric.wittmann@gmail.com
 * @author Jakub Senko <jsenko@redhat.com>
 * @class
 */
export interface IAai20Visitor extends IAaiVisitor {}


